import { defineComponent, ref } from 'vue'
import styles from './styles.module.scss'

export type MaskProps = {
  show: () => void
}

export default defineComponent({
  setup: (props, { expose }) => {
    const maskRef = ref(false)
    const hide = () => {
      maskRef.value = false
    }
    expose({
      show: () => {
        maskRef.value = true
      },
    })
    return () => {
      if (!maskRef.value) {
        return null
      }
      return (
        <>
          <div class={styles.mask}>
            <div class={styles.guide}>
              <img src="//cdn-app.nio.com/PE/2022/3/31/a9b4cfe8-4b3d-4497-b7b3-38474de916a4.png" />
            </div>
            <div class={styles.content}>
              <p>1. 点击右上角</p>
              <p>2. 用浏览器打开</p>
              {/* <p>3. 进入App</p> */}
            </div>
            <div class={styles.close}>
              <img
                src="//cdn-app.nio.com/PE/2022/3/31/7e9ae387-48b9-4e97-9e8d-32d928e0c8a9.png"
                onClick={hide}
              />
            </div>
          </div>
        </>
      )
    }
  },
})
